/*
  Collection of custom react hooks.
  Greatly inspired by react-use.
  https://github.com/streamich/react-use
*/

export { default as usePromise } from './usePromise';
export { default as useThrottleFn } from './useThrottleFn';
export { default as useEvent } from './useEvent';
export { default as useEffectOnce } from './useEffectOnce';
export { default as useUpdateEffect } from './useUpdateEffect';
export { default as useUnmount } from './useUnmount';
export { isClient } from './util';
export { default as useTimeoutFn } from './useTimeoutFn';
export { default as useClickAway } from './useClickAway';
export { default as useDebounce } from './useDebounce';
export { default as usePrevious } from './usePrevious';
